import _extends from "@babel/runtime-corejs2/helpers/esm/extends";
import _taggedTemplateLiteral from "@babel/runtime-corejs2/helpers/esm/taggedTemplateLiteral";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    margin-bottom: ", "px !important;\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    margin-bottom: ", "px !important;\n    font-size: ", "px;\n    line-height: ", "px;\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    margin-bottom: ", "px !important;\n    font-size: ", "px;\n    line-height: ", "px\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    margin-bottom: ", "px !important;\n    font-size: ", "px;\n    line-height: ", "px;\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import * as React from 'react';
import * as PropTypes from 'prop-types';
import styled from 'styled-components';
import { ptColor } from '../../consts/propTypes.const';
import { antialiased, inline, letterSpacing, overflow, textAlign, sansSerif, truncate, noSelect } from '../../helpers/typographyStyle.helper';
import { color } from '../../helpers/colorStyle.helper';
import { FontSizes, FontWeights, HeadingMargins, LineHeights } from '../../consts/metrics.const';
import { media } from '../../helpers/mediaStyle.helper';
var headingPropTypes = {
  text: PropTypes.string.isRequired,
  accessibilityLevel: PropTypes.oneOf([1, 2, 3, 4, 5, 6]),
  color: ptColor,
  truncate: PropTypes.bool,
  className: PropTypes.string,
  marginBottom: PropTypes.bool,
  noSelect: PropTypes.bool,
  fontWeight: PropTypes.oneOf(['regular', 'bold', 'medium']),
  align: PropTypes.oneOf(['left', 'right', 'center', 'justify']),
  'data-id': PropTypes.string,
  overflow: PropTypes.oneOf(['normal', 'breakWord'])
};
var headingDisplayName = 'leading';
var headingDefaultProps = {
  'data-id': headingDisplayName,
  overflow: 'normal',
  color: 'grey56',
  noSelect: false,
  align: 'left'
};
var BaseComponent = styled.h1.attrs({
  'data-id': function dataId(props) {
    return props['data-id'];
  }
}).withConfig({
  displayName: "Heading__BaseComponent",
  componentId: "x9xerk-0"
})(["margin-top:0;", ";", ";", ";", ";", ";", ";", ";", ";", ";"], antialiased, letterSpacing, sansSerif, textAlign, truncate, color, overflow, inline, noSelect);

var h1StylesWith = function h1StylesWith(tag) {
  return styled(BaseComponent.withComponent(tag)).withConfig({
    displayName: "Heading",
    componentId: "x9xerk-1"
  })(["margin-bottom:", "px !important;font-size:", "px;font-weight:", ";line-height:", "px;", ";"], function (_ref) {
    var marginBottom = _ref.marginBottom;
    return !marginBottom ? '0' : HeadingMargins.H1;
  }, FontSizes.H1, function (_ref2) {
    var fontWeight = _ref2.fontWeight;
    return fontWeight ? FontWeights[fontWeight.toUpperCase()] : FontWeights.REGULAR;
  }, LineHeights.H1, media.LG(_templateObject(), function (_ref3) {
    var marginBottom = _ref3.marginBottom;
    return !marginBottom ? '0' : HeadingMargins.Large.H1;
  }, FontSizes.Large.H1, LineHeights.Large.H1));
};

var h2StylesWith = function h2StylesWith(tag) {
  return styled(BaseComponent.withComponent(tag)).withConfig({
    displayName: "Heading",
    componentId: "x9xerk-2"
  })(["margin-bottom:", "px !important;font-size:", "px;font-weight:", ";line-height:", "px;", ";"], function (_ref4) {
    var marginBottom = _ref4.marginBottom;
    return !marginBottom ? '0' : HeadingMargins.H2;
  }, FontSizes.H2, function (_ref5) {
    var fontWeight = _ref5.fontWeight;
    return fontWeight ? FontWeights[fontWeight.toUpperCase()] : FontWeights.REGULAR;
  }, LineHeights.H2, media.LG(_templateObject2(), function (_ref6) {
    var marginBottom = _ref6.marginBottom;
    return !marginBottom ? '0' : HeadingMargins.Large.H2;
  }, FontSizes.Large.H2, LineHeights.Large.H2));
};

var h3StylesWith = function h3StylesWith(tag) {
  return styled(BaseComponent.withComponent(tag)).withConfig({
    displayName: "Heading",
    componentId: "x9xerk-3"
  })(["margin-bottom:", "px !important;font-size:", "px;font-weight:", ";line-height:", "px;", ";"], function (_ref7) {
    var marginBottom = _ref7.marginBottom;
    return !marginBottom ? '0' : HeadingMargins.H3;
  }, FontSizes.H3, function (_ref8) {
    var fontWeight = _ref8.fontWeight;
    return fontWeight ? FontWeights[fontWeight.toUpperCase()] : FontWeights.MEDIUM;
  }, LineHeights.H3, media.LG(_templateObject3(), function (_ref9) {
    var marginBottom = _ref9.marginBottom;
    return !marginBottom ? '0' : HeadingMargins.Large.H3;
  }, FontSizes.Large.H3, LineHeights.Large.H3));
};

var h4StylesWith = function h4StylesWith(tag) {
  return styled(BaseComponent.withComponent(tag)).withConfig({
    displayName: "Heading",
    componentId: "x9xerk-4"
  })(["margin-bottom:", "px !important;font-size:", "px;font-weight:", ";line-height:", "px;", ";"], function (_ref10) {
    var marginBottom = _ref10.marginBottom;
    return !marginBottom ? '0' : HeadingMargins.H4;
  }, FontSizes.H4, function (_ref11) {
    var fontWeight = _ref11.fontWeight;
    return fontWeight ? FontWeights[fontWeight.toUpperCase()] : FontWeights.MEDIUM;
  }, LineHeights.H4, media.LG(_templateObject4(), function (_ref12) {
    var marginBottom = _ref12.marginBottom;
    return !marginBottom ? '0' : HeadingMargins.Large.H4;
  }));
};

var Heading = function Heading(_ref13) {
  var text = _ref13.text,
      children = _ref13.children,
      accessibilityLevel = _ref13.accessibilityLevel,
      marginBottom = _ref13.marginBottom,
      noSelect = _ref13.noSelect,
      color = _ref13.color,
      overflow = _ref13.overflow,
      truncate = _ref13.truncate,
      size = _ref13.size,
      className = _ref13.className,
      fontWeight = _ref13.fontWeight,
      align = _ref13.align,
      dataId = _ref13['data-id'];
  var Component;
  var tag = "h".concat(accessibilityLevel || (size <= 4 ? size : 4));

  switch (size) {
    case 1:
      Component = h1StylesWith(tag);
      break;

    case 2:
      Component = h2StylesWith(tag);
      break;

    case 3:
      Component = h3StylesWith(tag);
      break;

    default:
      Component = h4StylesWith(tag);
      break;
  }

  return React.createElement(Component, {
    className: className,
    truncate: truncate,
    color: color,
    overflow: overflow,
    marginBottom: marginBottom,
    noSelect: noSelect,
    fontWeight: fontWeight,
    align: align,
    "data-id": dataId
  }, children || text);
};

var Heading1 = function Heading1(props) {
  return React.createElement(Heading, _extends({}, props, {
    size: 1
  }));
};

var Heading2 = function Heading2(props) {
  return React.createElement(Heading, _extends({}, props, {
    size: 2
  }));
};

var Heading3 = function Heading3(props) {
  return React.createElement(Heading, _extends({}, props, {
    size: 3
  }));
};

var Heading4 = function Heading4(props) {
  return React.createElement(Heading, _extends({}, props, {
    size: 4
  }));
}; // Prop types


Heading.propTypes = headingPropTypes;
Heading.displayName = headingDisplayName;
Heading.defaultProps = headingDefaultProps;
Heading1.displayName = 'Heading1';
Heading2.displayName = 'Heading2';
Heading3.displayName = 'Heading3';
Heading4.displayName = 'Heading4';
Heading1.defaultProps = headingDefaultProps;
Heading2.defaultProps = headingDefaultProps;
Heading3.defaultProps = headingDefaultProps;
Heading4.defaultProps = headingDefaultProps;
Heading1.propTypes = headingPropTypes;
Heading2.propTypes = headingPropTypes;
Heading3.propTypes = headingPropTypes;
Heading4.propTypes = headingPropTypes;
export { Heading, Heading1, Heading2, Heading3, Heading4 };